<template>
  <v-tooltip location="top" open-delay="500">
    <template v-slot:activator="{ props }">
      <v-avatar
        :style="{
          border: '1px solid ' + finalColor,
          color: finalColor
        }"
        :size="large ? 24 : 20"
        class="avatar large mx-1 show-on-hover-item"
        v-bind="props">

        <v-icon
          v-if="generatedByAi"
          :size="large ? 'small' : 'x-small'"
          :color="finalColor"
          style="margin: 1px 2px 0 0;"
        >
          mds:temp-preferences-custom
        </v-icon>
        <v-icon
          v-else-if="initials === '*'"
          :size="large ? 'default' : 'small'"
          :color="finalColor"
          style="margin: 0;"
        >
          mds:person
        </v-icon>
        <span v-else class="initials">{{ initials }}</span>
      </v-avatar>
    </template>

    <div>
      <p class="text-body-2 mb-0">{{ (generatedByAi ? 'Generated by AI by ' : '') + fullname }}</p>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  props: ['fullname', 'large', 'grayscale', 'generatedByAi'],

  computed: {
    initials () {
      const { fullname } = this

      if (typeof fullname !== 'string' || !fullname.trim().length) {
        return '*'
      }

      const [first, last] = this.fullname.split(' ')

      const f = first.charAt(0)
      const l = typeof last === 'string' ? last.charAt(0) : ''

      return f + l
    },

    initialsColor () {
      const str = this.initials
      let hash = 0x811C9DC5
      for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i) - 65
        hash = Math.imul(hash, 0x010000193)
        hash ^= hash >>> 7
      }
      hash = Math.abs(hash)

      const h = hash % 360
      const s = 75 + (hash % 10)
      const l = 25 + (hash % 20)
      const color = `hsl(${h}, ${s}%, ${l}%)`
      return color
    },

    finalColor () {
      if (this.grayscale || this.initials === '*') {
        return '#878F99'
      }

      return this.initialsColor
    }
  }
}
</script>

<style scoped>
.avatar {
  flex-shrink: 0;
  background: none !important;
}

.initials {
  text-transform: uppercase;
  text-align: right;
  font-size: 10px;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -0.3px;
}

.v-tooltip__content {
  background: white;
  color: var(--color-primary);
  border-radius: 10px;
}
</style>
